/**
 * 403 page shown when a non-Admin tries to open an /admin/* route
 * (Requirement 2.5).
 *
 * Migrated to Cloudscape (ContentLayout + Alert + Box + Button).
 */

import { useNavigate } from "react-router-dom";

import {
  Alert,
  Box,
  Button,
  ContentLayout,
  Header,
  SpaceBetween,
} from "@cloudscape-design/components";

import { useAuth } from "../auth/AuthContext";

export function AuthorizationError() {
  const { session } = useAuth();
  const navigate = useNavigate();
  const identity =
    session?.claims.email ??
    session?.claims["cognito:username"] ??
    "(not signed in)";

  return (
    <ContentLayout
      header={<Header variant="h1">Not authorized</Header>}
    >
      <SpaceBetween size="m">
        <Alert
          type="error"
          statusIconAriaLabel="Access denied"
          header="Access denied"
        >
          Your account does not have the <code>Admin</code> role required
          for this page.
        </Alert>
        <Box>
          You are signed in as <strong>{identity}</strong>.
        </Box>
        <Button onClick={() => navigate("/catalog")}>
          Return to the consumer catalog
        </Button>
      </SpaceBetween>
    </ContentLayout>
  );
}
